<template>
  <div class="solutions-container">
    <div class="solutions-header">
      <div class="solutions-subtitle">解决方案</div>
    </div>
    <div class="solutions-grid">
      <div
        v-for="(item, index) in solutionList"
        :key="index"
        class="solution-card"
      >
        <div class="solution-card-visual" aria-hidden="true">
          <div v-if="item.hoverImg" class="solution-card-icon-3d">
            <img
              :src="item.hoverImg"
              alt=""
              class="solution-card-visual-image"
            >
          </div>
        </div>
        <div class="solution-card-title">{{ item.title }}</div>
        <div class="solution-card-body">
          <div class="solution-card-desc">{{ item.desc }}</div>
          <router-link :to="item.link" class="solution-card-link">了解更多</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const solutionImageModules = import.meta.glob('../assets/homeSolution/*', {
  eager: true,
  import: 'default',
});

const solutionImageEntries = Object.entries(solutionImageModules).sort((a, b) =>
  a[0].localeCompare(b[0])
);

function getSolutionImage(keyword, fallbackIndex) {
  if (!solutionImageEntries.length) return '';
  const lower = String(keyword || '').toLowerCase();

  const matched = solutionImageEntries.find(([path]) =>
    path.toLowerCase().includes(lower)
  );

  if (matched) {
    return matched[1];
  }

  const fallback = solutionImageEntries[fallbackIndex];
  return fallback ? fallback[1] : '';
}

export default {
  name: "Solutions",
  data() {
    return {
      solutionList: [
        {
          title: '云安全解决方案',
          hoverImg: getSolutionImage('ai', 3),
          desc: '面向私有云的一体化安全能力供给与合规管控，集约交付防火墙、WAF、审计等能力，降低建设与运维成本，满足等保与数据安全要求。',
          link: '/solutions/private-cloud-security',
        },
        {
          title: 'AI基础设施解决方案',
          hoverImg: getSolutionImage('cloud', 0),
          desc: '统一纳管异构算力与模型运行环境，支撑推理部署、弹性扩缩与运维管控，为 AI 业务提供稳定、高效的算力与平台底座。',
          link: '/solutions/ai-infrastructure-solution',
        },
        {
          title: 'AI native 平台解决方案',
          hoverImg: getSolutionImage('sase', 2),
          desc: '以测试数字员工为切入点，把需求理解、用例生成、脚本执行、失败处理和知识沉淀连成可审计流程。',
          link: '/solutions/ai-native-platform',
        },
        {
          title: '边缘计算解决方案',
          hoverImg: getSolutionImage('flow', 4),
          desc: '构建云-边-端一体化架构，将核心能力下沉至边缘，联动云端实现全局管控，适配多行业边缘智能化落地。',
          link: '/solutions/edge-computing',
        },
        {
          title: 'AI场景智能应用解决方案',
          hoverImg: getSolutionImage('password', 5),
          desc: '把智能体能力交付到具体业务场景，帮助组织在客服、办公、运维等场景快速落地。',
          link: '/product/ai-agent-application',
        },
        {
          title: '算力网络解决方案',
          hoverImg: getSolutionImage('flow', 4),
          desc: '跨域互联、多云纳管与平台生态能力协同，构建可扩展的算力网络底座，支撑算力统一调度与业务协同落地。',
          link: '/solutions/compute-network-infrastructure',
        },
      ],
    };
  },
};
</script>

<style scoped>
.solutions-container {
  position: relative;
  padding: 64px 12%;
  width: 100%;
  box-sizing: border-box;
  background: #f3f4f6;
}

.solutions-header {
  position: relative;
  z-index: 1;
  margin-bottom: 56px;
  text-align: left;
}

.solutions-subtitle {
  font-size: 42px;
  font-weight: 800;
  line-height: 1.2;
  text-align: right;
  letter-spacing: 0.45em;
  background: none;
  -webkit-background-clip: border-box;
  background-clip: border-box;
  -webkit-text-fill-color: var(--color-home-heading);
  color: var(--color-home-heading);
  margin-bottom: 20px;
  padding-right: 0.45em;
}

.solutions-main-title {
  font-size: 32px;
  font-weight: 600;
  color: var(--color-primary);
  line-height: 1.4;
  text-align: center;
  max-width: 760px;
  margin: 0 auto;
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  width: 100%;
  align-items: stretch;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.solution-card {
  background: #ffffff;
  border: none;
  border-right: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  border-radius: 0;
  padding: 36px 32px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 300px;
  height: 100%;
  transition: background 0.25s ease;
  text-align: left;
  align-items: flex-start;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.solution-card:nth-child(3n) {
  border-right: none;
}

.solution-card:nth-child(n + 4) {
  border-bottom: none;
}

.solution-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
}

.solution-card::after {
  content: '';
  position: absolute;
  inset: auto -10% -28% auto;
  width: 180px;
  height: 180px;
  background: transparent;
  pointer-events: none;
}

.solution-card-visual {
  position: absolute;
  top: auto;
  right: 0;
  bottom: 0;
  width: 36%;
  height: 46%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 0 10px 16px 0;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  z-index: 0;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.solution-card-icon-3d {
  max-width: 100%;
  max-height: 78%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.solution-card:hover .solution-card-visual {
  opacity: 1;
  visibility: visible;
}

.solution-card-visual-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  filter: drop-shadow(0 12px 20px rgba(8, 145, 178, 0.18));
}

.solution-card-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 82%;
  flex: 1 1 auto;
  min-height: 0;
  z-index: 1;
}

.solution-card:hover {
  background: #dbeafe;
  box-shadow: none;
  border-color: #e5e7eb;
}

.solution-card-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: var(--color-home-heading);
  line-height: 1.4;
  text-align: left;
  width: 100%;
  max-width: 82%;
  margin-bottom: 12px;
  z-index: 1;
  position: relative;
}

.solution-card-desc {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.75;
  color: #334155;
  text-align: left;
  width: 100%;
  flex: 1 1 auto;
}

.solution-card-link {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  margin-top: auto;
  flex-shrink: 0;
  padding: 7px 0;
  border-radius: 0;
  background: none;
  color: var(--color-home-heading);
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  box-shadow: none;
  transition: opacity 0.2s ease;
  position: relative;
  z-index: 2;
}

.solution-card:hover .solution-card-link {
  color: var(--color-home-heading);
  box-shadow: none;
  transform: none;
}

@media (max-width: 992px) and (pointer: coarse) {
  .solutions-container {
    padding: 48px 5%;
  }

  .solutions-main-title {
    font-size: 28px;
  }

  .solutions-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0;
  }

  .solution-card:nth-child(3n) {
    border-right: 1px solid #e5e7eb;
  }

  .solution-card:nth-child(2n) {
    border-right: none;
  }

  .solution-card:nth-child(n + 4) {
    border-bottom: 1px solid #e5e7eb;
  }

  .solution-card:nth-child(n + 5) {
    border-bottom: none;
  }

  .solutions-subtitle {
    font-size: 32px;
  }

  .solution-card {
    min-height: 260px;
    height: auto;
    padding: 28px 24px;
  }

  .solution-card-visual-image {
    max-height: 100%;
  }

  .solution-card-title {
    font-size: 18px;
  }

  .solution-card-desc {
    font-size: 15px;
    font-weight: 600;
  }

  .solution-card-link {
    font-size: 15px;
  }
}

@media (max-width: 768px) and (pointer: coarse) {
  .solutions-container {
    padding: 40px 4%;
  }

  .solutions-header {
    margin-bottom: 32px;
  }

  .solutions-subtitle {
    font-size: 28px;
    line-height: 28px;
    margin-bottom: 40px;
  }

  .solutions-main-title {
    font-size: 24px;
  }

  .solutions-grid {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .solution-card,
  .solution-card:nth-child(3n),
  .solution-card:nth-child(2n),
  .solution-card:nth-child(n + 4),
  .solution-card:nth-child(n + 5) {
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }

  .solution-card:last-child {
    border-bottom: none;
  }

  .solution-card {
    padding: 24px 20px;
  }

  .solution-card-title {
    font-size: 17px;
  }

  .solution-card-desc {
    font-size: 15px;
    font-weight: 600;
  }
}

@media (max-width: 480px) and (pointer: coarse) {
  .solutions-container {
    padding: 32px 4%;
  }

  .solutions-subtitle {
    font-size: 28px;
    line-height: 28px;
    margin-bottom: 30px;
  }

  .solutions-main-title {
    font-size: 22px;
  }

  .solution-card {
    padding: 20px 18px;
  }
}
</style>
